import script from "./Custom.vue?vue&type=script&setup=true&lang=js"
export * from "./Custom.vue?vue&type=script&setup=true&lang=js"

import "./Custom.vue?vue&type=style&index=0&id=a90fa032&lang=scss&scoped=true"
script.__scopeId = "data-v-a90fa032"

export default script